import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'

// Get saved language from localStorage, default to Hebrew
const savedLanguage = localStorage.getItem('i18nextLng') || 'he'

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage, // Use saved language or Hebrew as default
    fallbackLng: 'he',
    supportedLngs: ['en', 'he'],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    backend: {
      loadPath: '/locales/{{lng}}/common.json',
    },

    react: {
      useSuspense: false, // Disable to prevent Suspense-related hangs
    },
  })

// Set document direction based on language
const setDirection = (lng: string) => {
  const dir = lng === 'he' ? 'rtl' : 'ltr'
  document.documentElement.dir = dir
  document.documentElement.lang = lng
}

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng)
  setDirection(lng)
})

// Set initial direction
setDirection(savedLanguage)

export default i18n
